import { collection, getDocs, addDoc, deleteDoc, doc, updateDoc, setDoc } from "firebase/firestore";
import { db, auth } from "../firebase";

export async function fetchPlaces() {
  const snapshot = await getDocs(collection(db, "places"));
  return snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export async function fetchCategories() {
  const snapshot = await getDocs(collection(db, "categories"));
  return snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export async function addCategory({ name, nameGeo, image, icon }) {
  const docRef = await addDoc(collection(db, "categories"), {
    name,
    nameGeo: nameGeo || "",
    image,
    icon,
    createdAt: new Date(),
    createdBy: auth.currentUser?.uid || "",
  });
  return { id: docRef.id, name, nameGeo: nameGeo || "", image, icon };
}

export async function updateCategory(id, { name, nameGeo, image, icon }) {
  await updateDoc(doc(db, "categories", id), {
    name,
    nameGeo: nameGeo || "",
    image,
    icon,
  });
  return { id, name, nameGeo: nameGeo || "", image, icon };
}

export async function deleteCategory(id) {
  await deleteDoc(doc(db, "categories", id));
}

export async function updatePlaceThumbnail(placeId, image) {
  await updateDoc(doc(db, "places", placeId), { image });
}

export async function updatePlaceSeasonMedia(placeId, field, season, urls) {
  const key = field === "images" ? "imagesBySeason" : "videosBySeason";
  await updateDoc(doc(db, "places", placeId), { [`${key}.${season}`]: urls });
}

export async function updatePlacePhotoAuthors(placeId, photoAuthors) {
  await updateDoc(doc(db, "places", placeId), { photoAuthors });
}

export async function fetchLegendTypes() {
  const snap = await getDocs(collection(db, "legendTypes"));
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export async function addPlace(newPlace) {
  const docRef = await addDoc(collection(db, "places"), newPlace);
  return { id: docRef.id, ...newPlace };
}

export async function updatePlace(id, updatedPlace) {
  await updateDoc(doc(db, "places", id), updatedPlace);
  return { id, ...updatedPlace };
}

export async function deletePlace(id) {
  await deleteDoc(doc(db, "places", id));
}


export async function addLegendType(name, nameKa) {
  const ref = doc(collection(db, "legendTypes"));
  await setDoc(ref, { name, nameKa: nameKa || "", createdAt: new Date() });
  return { id: ref.id, name, nameKa: nameKa || "" };
}

export async function updateLegendType(id, name, nameKa, createdAt) {
  await setDoc(doc(db, "legendTypes", id), {
    name,
    nameKa: nameKa || "",
    createdAt,
  });
}

export async function deleteLegendType(id) {
  await deleteDoc(doc(db, "legendTypes", id));
}